import ListElement from "../../navbars/elements/ListElement";
import ListHeader from "../../navbars/elements/ListHeader";
import SubList from "../../navbars/elements/SubList";
import { faBuilding, faPerson, faAddressBook } from "@fortawesome/free-solid-svg-icons";
import { faTableColumns } from "@fortawesome/free-solid-svg-icons";

const CrmSideNav = () => {
  return (
    <>
      <ListHeader title="CRM" link="/crm/settings" />
      <ListElement
        name="Contacts"
        icon={faAddressBook}
        topElement
      >
        <SubList>
          <ListElement
            name="Companies"
            icon={faBuilding}
            targetUrl="/crm/companies"
          />
          <ListElement
            name="People"
            icon={faPerson}
            targetUrl="/crm/people"
          />
        </SubList>
      </ListElement>
      <ListElement
        name="Pipelines"
        icon={faTableColumns}
        targetUrl="/crm/pipeline"
      />
    </>
  );
};

export default CrmSideNav;
